var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"save",attrs:{"viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M28 0h-28v32h32v-28l-4-4zM16 4h4v8h-4v-8zM28 28h-24v-24h2v10h18v-10h2.343l1.657 1.657v22.343z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }